import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    field: undefined,
};

export default createReducer(initial, {
    [actions.setField]: (state, action) => {
        return {
            ...state,
            field: action.payload,
        };
    },
});
